/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisibilityEnum } from './visibilityEnum';
import { SeverityEnum } from './severityEnum';


export interface ProviderComponentHealthDetails { 
    /**
     * Message id
     */
    message_id?: string;
    severity?: SeverityEnum;
    visibility?: VisibilityEnum;
    /**
     * Error code
     */
    code?: string;
    /**
     * Error message
     */
    message?: string;
    args?: Array<string>;
}
export namespace ProviderComponentHealthDetails {
}


